import { Button, Tooltip } from '@mui/material';
import { IPixAccountViewModel } from 'viewModels';
import { v4 as uuid } from 'uuid';
import { ReactComponent as PixIcon } from '../../assets/icons/IconPix.svg';
import { usePixAccounts } from '../../context/pixAccounts';
import { labelPixType, PixType } from '../../types/enums';
import { Container, Content } from './styles';
import { toCpfMask } from '../../utils/toCpfMask';
import { toCnpjMask } from '../../utils/toCnpjMask';

interface PixAccountsProps {
  onCallBack: (item: IPixAccountViewModel) => void;
  filterAccounts?: (item: IPixAccountViewModel) => boolean;
  runningTutorial: boolean;
  selectedPix?: IPixAccountViewModel;
  elementId?: string;
  type: 'user' | 'correspondent';
  correspondentPixAccounts?: IPixAccountViewModel[];
}
export function PixAccounts({
  onCallBack,
  filterAccounts,
  runningTutorial,
  elementId,
  correspondentPixAccounts,
  selectedPix,
  type,
}: PixAccountsProps) {
  const { pixAccounts } = usePixAccounts();
  const pixAccountTutorial: IPixAccountViewModel[] = [
    {
      id: uuid(),
      key: '12345678901',
      isPreferred: true,
      type: PixType.CPF,
    },
  ];
  const handleSelectPixAccount = (item: IPixAccountViewModel) => {
    onCallBack(item);
  };

  return (
    <Container>
      {type === 'user' && (
        <>
          {runningTutorial &&
            pixAccountTutorial.map((item) => (
              <Content isActive={selectedPix?.id === item.id} key={item.id + uuid()} id={elementId}>
                <Button onClick={() => handleSelectPixAccount(item)}>
                  {item.isPreferred && <div className="preferential" />}
                  <Tooltip disableInteractive title={item.key} placement="top" followCursor>
                    <div className="header">
                      <PixIcon />
                      <h1>{item.key}</h1>
                    </div>
                  </Tooltip>
                  {Object.keys(PixType)
                    .filter((key) => Number(key) === item.type)
                    .map((key) => (
                      <p key={key}>
                        Tipo
                        <span>{labelPixType[key as unknown as PixType]}</span>
                      </p>
                    ))}
                </Button>
              </Content>
            ))}
          {!runningTutorial &&
            pixAccounts.filter(filterAccounts || ((pix) => pix)).map((item) => (
              <Content isActive={selectedPix?.id === item.id} key={item.id}>
                <Button onClick={() => handleSelectPixAccount(item)}>
                  {item.isPreferred && <div className="preferential" />}
                  <Tooltip disableInteractive title={item.key} placement="top" followCursor>
                    <div className="header">
                      <PixIcon />
                      <h1>{item.key}</h1>
                    </div>
                  </Tooltip>
                  <div className="content">
                    {Object.keys(PixType)
                      .filter((key) => Number(key) === item.type)
                      .map((key) => (
                        <p key={key}>
                          Tipo
                          <span>{labelPixType[key as unknown as PixType]}</span>
                        </p>
                      ))}
                    <div className="holder">
                      {item.holderDocument && (
                        <p>
                          Documento
                          <span>
                            {item.holderDocument.length > 11
                              ? toCnpjMask(item.holderDocument)
                              : toCpfMask(item.holderDocument)}
                          </span>
                        </p>
                      )}
                      {item.holderName && (
                        <p>
                          Nome <span>{item.holderName}</span>
                        </p>
                      )}
                    </div>
                  </div>
                </Button>
              </Content>
            ))}
        </>
      )}
      {type === 'correspondent' && correspondentPixAccounts && (
        <>
          {correspondentPixAccounts.filter(filterAccounts || ((pix) => pix)).map((item) => (
            <Content isActive={selectedPix?.id === item.id} key={item.id}>
              <Button onClick={() => handleSelectPixAccount(item)}>
                {item.isPreferred && <div className="preferential" />}
                <Tooltip disableInteractive title={item.key} placement="top" followCursor>
                  <div className="header">
                    <PixIcon />
                    <h1>{item.key}</h1>
                  </div>
                </Tooltip>
                {Object.keys(PixType)
                  .filter((key) => Number(key) === item.type)
                  .map((key) => (
                    <p key={key}>
                      Tipo
                      <span>{labelPixType[key as unknown as PixType]}</span>
                    </p>
                  ))}
              </Button>
            </Content>
          ))}
        </>
      )}
    </Container>
  );
}
